import React from 'react';
import { BaseWidget, Type } from '@react-awesome-query-builder/core';
import { BasicConfig } from '@react-awesome-query-builder/ui';
import { MuiConfig, MuiWidgets } from '@react-awesome-query-builder/mui';
import { Button } from './widgets/Button';
import { CampaignSearchWidget } from './widgets/CampaignSearchWidget';
import { Conjs } from './widgets/Conjs';
import { excludedOperators, queryBuilderTheme } from './settings';
import { makeOperators } from './operators';

type CustomWidgets = BasicConfig['widgets'] & { campaign: BaseWidget };
type CustomTypes = BasicConfig['types'] & { campaign: Type };

export function initialConfig(
  translator: (translationKey: string) => string,
  readOnly = false,
): BasicConfig {
  return {
    ...MuiConfig,
    settings: {
      ...MuiConfig.settings,
      renderConjs: Conjs,
      renderButton: Button,
      /*
       * TODO in mui 6.1+, a new settings.renderField has been created, and a new factory for 'select' has been set
       *  - https://github.com/ukrbublik/react-awesome-query-builder/blob/6f4d7460982ee74faaaad2766b10f7e955e526e3/packages/mui/modules/config/index.jsx#L39
       *  - https://github.com/ukrbublik/react-awesome-query-builder/blob/6f4d7460982ee74faaaad2766b10f7e955e526e3/packages/mui/modules/config/index.jsx#L77
       *  I was not able to force the select by setting 'showSearch: false', but leave it here for the person who will try to fix this
       *  As a workaround, I have overridden the settings.renderFields in
       */
      renderField: (props: any) => <MuiWidgets.MuiFieldSelect {...props} />,
      theme: {
        mui: queryBuilderTheme,
      },
      addGroupLabel: 'Add a group of criteria',
      addRuleLabel: 'Add a criterion',
      notLabel: 'Not',
      showErrorMessage: true,
      immutableFieldsMode: readOnly,
      immutableGroupsMode: readOnly,
      immutableOpsMode: readOnly,
      immutableValuesMode: readOnly,
    },
    operators: makeOperators(translator),
    fields: {},
    widgets: {
      ...MuiConfig.widgets,
      datetime: {
        ...MuiConfig.widgets.datetime,
        valueFormat: 'YYYY-MM-DDTHH:mm:00.000Z',
      },
      select: {
        ...MuiConfig.widgets.select,
        // TODO not doing anything so far, but will be useful in the future (see comment above)
        showSearch: false,
        asyncFetch: undefined,
        customProps: {
          showSearch: false,
        },
      },
      campaign: {
        ...MuiConfig.widgets.text,
        type: 'campaign',
        factory: props => {
          return <CampaignSearchWidget {...props} />;
        },
      },
    } as CustomWidgets,
    types: {
      ...MuiConfig.types,
      campaign: {
        defaultOperator: 'equal',
        mainWidget: 'campaign',
        valueSources: ['value'],
        excludeOperators: excludedOperators,
        widgets: {
          campaign: {
            operators: ['equal', 'not_equal'], // TODO add applicable operators here
          },
        },
      },
    } as CustomTypes,
  };
}

export { profileFields } from './event-fields/profile-fields';
export { shouldBeApositiveNumber } from './event-fields/should-be-apositive-number';
